export default __webpack_public_path__ + "static/media/breakfast-overlay.a0f729c1.png";